import React, { useState } from 'react';
import AgreementBody from './AgreementBody';

export default function AgreementCard({ agreement, checkedItems, onChange }) {
  const [showFull, setShowFull] = useState(false);
  const items = agreement.acknowledgment_items || [];

  return (
    <div className="border border-gray-300 rounded-lg p-4 bg-white">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-gray-900">{agreement.name}</h3>
        <button
          type="button"
          onClick={() => setShowFull((v) => !v)}
          className="text-sm text-blue-600 hover:underline"
        >
          {showFull ? 'Hide full agreement' : 'Read the full agreement'}
        </button>
      </div>

      {showFull && (
        <div className="mt-3 max-h-80 overflow-y-auto rounded border border-gray-200 bg-gray-50 px-5 py-4">
          <AgreementBody
            markdown={agreement.body_markdown}
            className="font-serif text-[12.5px] leading-snug text-gray-800 [&_h1]:text-base [&_h1]:font-semibold [&_h1]:mt-4 [&_h1]:mb-2 [&_h2]:text-sm [&_h2]:font-semibold [&_h2]:mt-3 [&_h2]:mb-1 [&_h3]:text-[13px] [&_h3]:font-semibold [&_p]:my-2 [&_p]:text-justify [&_li]:my-0.5 [&_ul]:pl-5 [&_ol]:pl-5"
          />
        </div>
      )}

      <div className="mt-4 space-y-2">
        {agreement.acknowledgment_mode === 'single' ? (
          <label className="flex items-start gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={!!checkedItems.__single__}
              onChange={(e) => onChange({ __single__: e.target.checked })}
            />
            <span className="text-sm text-gray-700">
              I have read and agree to the {agreement.name}.
            </span>
          </label>
        ) : (
          items.map((item) => (
            <label key={item.id} className="flex items-start gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={!!checkedItems[item.id]}
                onChange={(e) => onChange({ ...checkedItems, [item.id]: e.target.checked })}
              />
              <span className="text-sm text-gray-700">{item.label}</span>
            </label>
          ))
        )}
      </div>
    </div>
  );
}
